<template>
    <div>
        <h2>{{caseData.title}}</h2>
        <div class="header-links">
            <div>
                <a :href="'/classroom/' + classroomID + '?assignment=' + assignmentID">
                    &lt;&lt; To Assignment
                </a>
            </div>
            <div>
                <a :href="'/cases/' + caseID + '?classroom=' + classroomID + '&assignment=' + assignmentID" target="_blank">
                    View Case
                </a>
            </div>
        </div>
        <hr>
        <md-tabs class="assignment-review-tabs">
            <md-tab md-label="Slide Performance">    
                <div style="display: block; width: 200px; margin: auto;">   
                    <md-field>
                        <label>Auto-Refresh Data:</label>
                        <md-select v-model="responseRefreshInterval">
                            <md-option value=0 >Never</md-option>
                            <md-option value=5>Every 5s</md-option>
                            <md-option value=10>Every 10s</md-option>
                            <md-option value=30>Every 30s</md-option>
                            <md-option value=300>Every 5m</md-option>
                        </md-select>
                    </md-field>
                </div>
                <hr>         
                <ResponseDashboard :slideDeck="slideDeck" :responseData="responseData" :indicatorData="[]"/>
            </md-tab>
            <md-tab md-label="Learner Performance" style="height: 600px;">
                <md-table v-model="learnerScores" md-sort="name" md-sort-order="asc" md-fixed-header>
                    <md-table-toolbar>
                        <h2 class="md-title">Learner Performance Breakdown</h2>
                    </md-table-toolbar>
                    <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Full Name" md-sort-by="fullName">
                            <router-link :to="'/classroom/' + classroomID + '/learner/' + item.pid">
                                {{ item.fullName }}
                            </router-link>
                        </md-table-cell>
                        <md-table-cell md-label="Time On Case" md-sort-by="timeOnCase">
                            {{ isFinite(item.timeOnCase) ? (item.timeOnCase ? (item.timeOnCase / 60).toFixed(1) + " min." : "N/A") : "INCOMPLETE"}}
                        </md-table-cell>
                        <md-table-cell md-label="VBM Score" md-sort-by="vbmScore.totalCost">
                           {{ (item.vbmScore.totalCost && item.vbmScore.maxCost) ?  "$" + item.vbmScore.totalCost + " out of $" + item.vbmScore.maxCost : "N/A"}}
                        </md-table-cell>
                        <md-table-cell md-label="Lab Score" md-sort-by="labScore">
                            {{ item.labScore ? item.labScore + "%" : "N/A"}}
                        </md-table-cell>
                        <md-table-cell md-label="DDx Score" md-sort-by="ddxScore">
                            {{ item.ddxScore ? item.ddxScore + "%" : "N/A"}}
                        </md-table-cell>
                        <md-table-cell md-label="Knowledge Score" md-sort-by="knowledgeScore">
                            {{ item.knowledgeScore ? item.knowledgeScore + "%" : "N/A"}}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-tab>
            <md-tab md-label="Case Completion">
                <md-table v-model="completionData" md-sort="name" md-sort-order="asc" md-fixed-header>
                    <md-table-toolbar>
                        <h2 class="md-title">Case Completion</h2>
                    </md-table-toolbar>
                    <md-table-row slot="md-table-row" slot-scope="{ item }"
                    :style="{'background-color': (item.completed ? '#c3f5ce' : '#ffc0c0')}">
                        <md-table-cell md-label="Full Name" md-sort-by="fullName">
                            <router-link :to="'/classroom/' + classroomID + '/learner/' + item.pid">
                                {{ item.fullName }}
                            </router-link>
                        </md-table-cell>
                        <md-table-cell md-label="Email" md-sort-by="email">
                            <a :href="'mailto:' + item.email">
                                {{ item.email }}
                            </a>
                        </md-table-cell>
                        <md-table-cell md-label="Completed" md-sort-by="completed">
                            {{ item.completed ? "Yes" : "No" }}
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-tab>
        </md-tabs>
    </div>
</template>

<script>
    import APIRequests from "../APIRequests.js"
    import ResponseDashboard from "./ResponseDashboard.vue"
    
    export default {
        components: {
            ResponseDashboard
        },
        props: {
            classroomID: {
                type: String
            },
            assignmentID: {
                type: String
            },
            caseID: {
                type: String
            },
        },
        data: function(){
            return {
                caseData: {},
                slideDeck: {},
                classroomData: {},
                classroomProfiles: [],
                completionData: [],
                responseData: [],
                reviewData: [],
                learnerScores: {},
                editorMode: false,
                responseRefreshInterval: 0,
                responseRefresher: undefined,
            }
        },
        watch: {
            responseRefreshInterval: function(){
                clearInterval(this.responseRefresher)
                if(this.responseRefreshInterval == 0) return
                this.responseRefresher = setInterval(() => {
                    this.getResponses()
                }, this.responseRefreshInterval*1000)
            }
        },
        computed: {
            
        },
        methods: {
            getClassroomData: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/" + this.classroomID
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data.classroomData) data.classroomData = {assignments: []}
                    this.classroomData = data.classroomData
                    this.editorMode = data.editorMode
                    if(this.editorMode){ 
                        if(!data.classroomProfiles) data.classroomProfiles = []
                        this.classroomProfiles = data.classroomProfiles
                        this.completionData = this.classroomProfiles.map((profileEntry => {
                            profileEntry.completed = this.reviewData.some((reviewEntry => {
                                return reviewEntry.pid == profileEntry.pid
                            }))
                            return profileEntry
                        }))
                    }
                })
            },
            getResponses: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/" + this.classroomID + "/responses/" + this.assignmentID + "/" + this.caseID
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data) data=[]
                    this.responseData = data
                })
            },
            
            scoreLearners: function(){
                this.learnerScores = this.classroomProfiles.map((profileEntry) => {
                    const firstAttempt = this.responseData.filter(resp => resp.pid == profileEntry.pid && resp.attempt == 1);
                    const timepoints = firstAttempt.map((resp) => resp.finishTime);
                    const firstTimepoint = Math.min(...timepoints)
                    const lastTimepoint = Math.max(...timepoints);
                    const timeOnCase = lastTimepoint - firstTimepoint;
                    // Run over each lab slide in the attempt and add up total spent as well as total possible to spend
                    const vbmScore = firstAttempt.filter((resp) => resp.slideType == "Labs").reduce((agg, resp) => {
                        if(resp.performance.Labs && resp.performance.Labs.totalCost && resp.performance.Labs.maxCost){
                            agg.totalCost += resp.performance.Labs.totalCost;
                            agg.maxCost += resp.performance.Labs.maxCost;
                        }
                        return agg;
                    }, {totalCost: 0, maxCost: 0});
                    // Sum up all scores on labs (determined by missed or unecessary lab purchases) and then take avg.
                    const calcQuestionAvgPct = function(slideType){
                        var totalScore = 0;
                        var totalPct = 0;
                        firstAttempt.forEach((responseElem) => {
                            if(responseElem.performance && Object.keys(responseElem.performance).includes(slideType)){
                                totalScore += responseElem.score
                                totalPct += 100
                            }
                            // Hack to include MC and checklist in knowledge score
                            if(slideType == "Checklist" && responseElem.performance && Object.keys(responseElem.performance).includes("Multiple Choice")){
                                totalScore += responseElem.score
                                totalPct += 100
                            }
                        })
                        return  100 * totalScore / totalPct
                    }
                    const labScore = calcQuestionAvgPct("Labs")
                    const ddxScore = calcQuestionAvgPct("Diagnosis")
                    const knowledgeScore = calcQuestionAvgPct("Checklist")
                    return {fullName: profileEntry.fullName, pid: profileEntry.pid, timeOnCase, vbmScore, labScore, ddxScore, knowledgeScore}
                });
            },
            getReviews: function(){
                var api_url = this.$store.state.api_url + "/api/classrooms/" + this.classroomID + "/reviews/" + this.assignmentID + "/" + this.caseID
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    if(!data) data=[]
                    this.reviewData = data
                })
            },
            fetchCase: function () {
				var api_url = this.$store.state.api_url + "/api/cases/" + this.caseID
				return APIRequests.getJSONData(api_url, this.$store.state.jwtToken).then((data) => {
					this.caseData = data;
				})
            },
            createSlideDeck: function(){
				var slideDeck = {}
				var collectSlides = function(activityObj, activityName){
					for (var i in activityObj) {
						var entry = activityObj[i]
						entry.type = activityName
						//entry.complete = false
						slideDeck[entry.slide.order] = entry
					}
				}
				collectSlides(this.caseData.history, "History")
				collectSlides(this.caseData.physical_exams, "Physical Exam")
				collectSlides(this.caseData.labs, "Labs")
				collectSlides(this.caseData.sa_questions, "Short Answer")
				collectSlides(this.caseData.mc_questions, "Multiple Choice")
				collectSlides(this.caseData.ck_questions, "Checklist")
				collectSlides(this.caseData.ddx_questions, "Diagnosis")
				collectSlides(this.caseData.education, "Education")
				this.slideDeck = slideDeck
			},
        },
        mounted: function(){
            this.$nextTick(function () {
                this.fetchCase().then(() => {
                    this.createSlideDeck()
                    return this.getResponses()
                }).then(() => this.getReviews())
                .then(() =>  this.getClassroomData())
                .then(() => this.scoreLearners())
            })
        }
    }
</script>

<style scoped>
    .header-links {
        display: flex;
        justify-content: space-around;
        max-width: 500px;
        margin: auto;
        margin-top: 24px;
    }
    .header-links a {
        color: black !important;
        font-weight: bold;
    }
    .assignment-review-tabs >>> .md-tabs-content{
        height: auto !important;
    }
</style>
